import React from "react"
import clsx from "clsx"
import { FaCheck, FaTimes } from "react-icons/fa"

import classes from "./Checkbox.module.scss"

const Checkbox = props => {
  const {
    className = "",
    checked = false,
    disabled = false,
    showNotChecked = false,
    onChange = () => { },
    ...otherProps
  } = props

  return (
    <div
      className={clsx(classes["checkbox-container"], className)}
      onClick={e => !disabled && onChange(!checked, e)}
      {...otherProps}
    >
      <input
        className={classes["hidden-checkbox"]}
      />
      <div
        className={clsx(classes["checkbox"],
          checked && classes["checkbox-checked"],
          showNotChecked && !checked && classes["checkbox-not-checked"],
          disabled && classes["checkbox-disabled"],
          checked && disabled && classes["checkbox-checked-disabled"]
        )}
      >
        {checked
          ? <FaCheck size={12} className={classes["check"]} />
          : showNotChecked && <FaTimes size={12} className={classes["check"]} />
        }
      </div>
    </div>
  )
}

export default Checkbox
